import { AloftDate, XMLPropertyResult } from '@aloft/toolkit-shared';

import { validateUADReportXMLV2 } from './validateUADReportXML.js';
import { extractXMLPropertyResults } from './xmlExtraction/extractXMLPropertyResults.js';

export const parseUpload = ({
  upload,
}: {
  upload: string;
}): {
  subject: XMLPropertyResult;
  comps: XMLPropertyResult[];
  effectiveDate?: AloftDate;
  formType: string;
} => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(upload, 'text/xml');

  const validationErrors = validateUADReportXMLV2(doc);
  if (validationErrors.length > 0) {
    console.warn(validationErrors);
    throw new Error('Invalid XML');
  }

  const { subject, comps, effectiveDate, formType } = extractXMLPropertyResults(doc);

  return {
    subject,
    comps,
    effectiveDate,
    formType,
  };
};
